import { render, staticRenderFns } from "./BaseBreadcrumb.vue?vue&type=template&id=6a7e4c38&lang=pug"
import script from "./BaseBreadcrumb.vue?vue&type=script&lang=js"
export * from "./BaseBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./BaseBreadcrumb.vue?vue&type=style&index=0&id=6a7e4c38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports